import * as api from '../api/index'
import { AUTH, CREATE_PROFILE, LOGOUT } from './constants'
import { setAccessToken, clearAccessToken } from '../utils/tokenManager'

const getAuthErrorMessage = (error, fallback = 'Request failed. Please try again.') => {
    const apiMessage = error?.response?.data?.message
    if (typeof apiMessage === 'string' && apiMessage.trim()) return apiMessage.trim()
    const networkMessage = error?.message
    if (typeof networkMessage === 'string' && networkMessage.trim()) return networkMessage.trim()
    return fallback
}


export const signin =(formData, openSnackbar, setLoading) => async(dispatch) => {

    try {
        //login the user
        const { data } = await api.signIn(formData)
        setAccessToken(data?.token, data?.expiresIn)
        dispatch({ type: AUTH, data})
        // setLoading(false)
        openSnackbar("Signin successfull")
        // history.push('/dashboard')
        window.location.href="/dashboard"

    } catch (error) {
        openSnackbar(getAuthErrorMessage(error, 'Sign in failed. Please try again.'))
        setLoading(false)
    }
}

export const signup =(formData, openSnackbar, setLoading) => async(dispatch) => {

    try {
        //Sign up the user
        const { data } = await api.signUp(formData)
        setAccessToken(data?.token, data?.expiresIn)
        dispatch({ type: AUTH, data})
        const { info } = await api.createProfile({name: data?.result?.name, email: data?.result?.email, userId: data?.result?._id, phoneNumber: '', businessName: '', contactAddress: '', logo: '', website: ''});
        dispatch({ type: CREATE_PROFILE, payload: info });
        window.location.href="/dashboard"
        // history.push('/dashboard')
        openSnackbar("Sign up successfull")

    } catch (error) {
        console.log(error)
        openSnackbar(getAuthErrorMessage(error, 'Sign up failed. Please try again.'))
        setLoading(false)
    }
}



export const forgot =(formData) => async(dispatch) => {
    try {
        await api.forgot(formData)
    } catch (error) {
        console.log(error)
    }
}


export const reset =(formData, history) => async(dispatch) => {

    try {
        await api.reset(formData)
        history.push('/dashboard')

    } catch (error) {
        alert(error)
    }
}

export const refreshSession = () => async (dispatch, getState) => {
    try {
        const { data } = await api.refreshToken()
        if (data?.token) {
            setAccessToken(data.token, data.expiresIn)
            dispatch({ type: AUTH, data })
        }
    } catch (error) {
        clearAccessToken()
        if (getState()?.auth?.authData) {
            dispatch({ type: LOGOUT })
        }
    }
}

export const logoutUser = () => async (dispatch) => {
    try {
        await api.logout()
    } catch (error) {
        console.log(error)
    } finally {
        clearAccessToken()
        dispatch({ type: LOGOUT })
    }
}
